"use strict";

require("core-js/modules/es.regexp.constructor");
require("core-js/modules/es.regexp.exec");
require("core-js/modules/es.regexp.to-string");
require("core-js/modules/es.string.replace");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preparePhone = void 0;
function maskString(value, mask, symbol) {
  var i = 0;
  return mask.replace(new RegExp(symbol, 'g'), function () {
    return value[i++];
  });
}
var preparePhone = {
  forUI(phone) {
    return maskString(phone.replace(/[^0-9]/g, '').replace(/^7/, ''), '+7 (999) 999-99-99', '9');
  },
  forService(phone) {
    return "7" + phone.replace(/[^0-9]/g, '').replace(/^7/, '');
  }
};
exports.preparePhone = preparePhone;